const formatDateTime = (string?: string, pattern?: string) => {
	if (!string) return { date: "", time: "" };

	const d = new Date(string);

	const optionsDate: Intl.DateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
	let date = d.toLocaleDateString("en-MY", optionsDate);

	if (pattern) date = date.split("/").join(pattern);

	const optionsTime: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "2-digit", hour12: true };
	const time = d.toLocaleTimeString("en-MY", optionsTime);

	return { date, time };
};

export default formatDateTime;
